import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404 - Page Not Found</h1>
      <p style={styles.text}>The page you're looking for doesn't exist.</p>
      <Link to="/" style={styles.link}>← Back to Home</Link>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fee2e2',
    color: '#991b1b',
    padding: '2rem',
    borderRadius: '1rem',
    margin: '2rem',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)'
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold'
  },
  text: {
    fontSize: '1.2rem',
    marginTop: '1rem'
  },
  link: {
    marginTop: '2rem',
    textDecoration: 'none',
    backgroundColor: '#dc2626',
    color: 'white',
    padding: '0.6rem 1.2rem',
    borderRadius: '9999px',
    fontWeight: 'bold'
  }
};
